import { NessLabsSettingMuiF } from '../Mui/module/NessLabsSettingMuiF.js';
import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { MShopUtilF } from '../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { go } from 'fxjs/es';
import { $closest, $data, $delegate, $find, $on } from 'fxdom/es';
import { NessLabsSettingF } from './module/NessLabsSettingF.js';
import { MotionButtonHandler } from './events.js';
import { smoothScrollTopAndRemember, smoothScrollToSaved } from './scroll.js';
import { CharacterValidatorS } from '../../../S/Function/character.js';
import { MShopAppProductDetailF } from '../../../../MShop/App/ProductDetail/F/Function/module/MShopAppProductDetailF.js';

export const openSetting = async (character, generateFunc) => {
  let saved_position = window.pageYOffset;
  if (MShopUtilF.isMobile()) {
    if (window.visualViewport) {
      if (window.visualViewport.height !== document.documentElement.clientHeight) {
        saved_position = await smoothScrollTopAndRemember();
      }
    }
    // scrollTo(0, 0)도 header로 인해 최상단으로 이동하지 않아서 한번 더 처리
    window.scrollTo({
      top: -1,
      behavior: 'smooth',
    });
  }

  return MuiF.openFrame(NessLabsSettingMuiF.frame, async (frame, page, [tab]) => {
    const { motions } = box();
    const is_mobile = MShopUtilF.isMobile();
    frame.title = 'Character Setting';
    frame.hide_frame_button_type = 'X';
    frame.always_remove = true;
    frame.animation = true;
    frame.prev_frame_show = true;
    frame.is_modal = !is_mobile;
    MShopAppProductDetailF.makePdFormToSticky(true);

    frame.showing = () => {
      if (is_mobile) {
        window.scrollTo({
          top: 1,
          behavior: 'smooth',
        });
      }
    };
    frame.closed = async () => {
      MShopAppProductDetailF.makePdFormToSticky(false);
      if (is_mobile) {
        await smoothScrollToSaved(saved_position);
      }
    };
    tab.makeData = () => ({
      ...character,
      motions,
    });
    tab.appended = (tab_el) => {
      go(
        tab_el,
        $delegate('click', '.cancel-button', () => MuiF.removeFrame()),
        $delegate('click', '.select-option', NessLabsSettingF.handleCharacterBySelect),
        $delegate('click', '.motion-select', NessLabsSettingF.handleMotionSelect),
        $delegate('click', '.generate-button', async ({ currentTarget: ct }) => {
          const container = $closest('.avatar-setting', ct);
          const [emotion, action, weapon] = MotionButtonHandler.getActiveMotionsInSelectBox(container);
          const data = go(container, $find('.avatar-setting__preview'), $data);

          if (CharacterValidatorS.compareCharacter(character, data)) {
            MuiF.removeFrame();
            return;
          }

          data.selected_motions = {
            action,
            weapon,
            emotion,
          };
          generateFunc(data);
          MuiF.removeFrame();
        }),

        $on('click', (e) => {
          if (!e.target.closest('.motion-select') && !e.target.closest('.select-options')) {
            NessLabsSettingF.closeCurrentOptions();
          }
        }),
      );
    };
  });
};
